export const fullApps = [
  
  {
    id: 6,
    title: "VK: music, video, messenger",
    subtitle: "Social",
    rating: 4.2,
    ratingCount: "1.2M",
    price: 0,
    rank: 6,
    color: "#0077FF",
    icon: "https://play-lh.googleusercontent.com/oCQAavUULT3r2vWbt1e4xm8ETArEeYZ-ggqvRl-IvLPL5zcpnFpcwAwmHUB1oYXFYdE-AsjZLPGRtk8rs_cn7A",
  },
  {
    id: 7,
    title: "Okko: фильмы, сериалы, спорт",
    subtitle: "Entertainment",
    rating: 4.3,
    ratingCount: "580K",
    price: 0,
    rank: 7,
    color: "#FF6B00",
    icon: "https://play-lh.googleusercontent.com/3qi0muO8onegHHOxSH6MP8_9ZyjaV-B1Dh8J5tkpPr-4Q7SYijeqoox41mCb93pF0NChJc6Nzu2CnKUZFg78EA",
  },
  {
    id: 8,
    title: "VK Музыка: песни и подкасты",
    subtitle: "Music",
    rating: 4.4,
    ratingCount: "890K",
    price: 0,
    rank: 8,
    color: "#0077FF",
    icon: "https://play-lh.googleusercontent.com/WLutS1BYg12BUmB34-r0uoSKyRX-LyLif9snMRSXxrI-7MP6hgwI2_zm9C1kBF4XpsCUzEpquOWEdFAvJ7gyOQ",
  },
  {
    id: 9,
    title: "Пятёрочка: доставка продуктов",
    subtitle: "Shopping",
    rating: 4.5,
    ratingCount: "1.5M",
    price: 0,
    rank: 9,
    color: "#FF6600",
    icon: "https://play-lh.googleusercontent.com/n_yJL6NanXEcupxhb15vRba4lSBcVf4fYtEKwr-ufQZG5buLnxgOo90R6O6pRK_wgA2mtLj8yChfRF17lYBr",
  },
  {
    id: 10,
    title: "Ozon Банк",
    subtitle: "Finance",
    rating: 4.3,
    ratingCount: "420K",
    price: 0,
    rank: 10,
    color: "#005BFF",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource211/v4/8a/ea/37/8aea3749-f032-039f-5444-26d65511aa21/Placeholder.mill/0x514h.jpg",
  },
  {
    id: 11,
    title: "Threads",
    subtitle: "Social",
    rating: 3.8,
    ratingCount: "2.1M",
    price: 0,
    rank: 11,
    color: "#000000",
    icon: "https://play-lh.googleusercontent.com/6PzXaP0KaRU4DifAfsXKbWNVA3JPrP9uklvEh5EDhzPRdPfHV4tzszhAavQa4bq0YGdbnphBucz9vEUXiu1Ebg",
  },
  {
    id: 12,
    title: "VK Знакомства: общение, чат",
    subtitle: "Social",
    rating: 4.1,
    ratingCount: "780K",
    price: 0,
    rank: 12,
    color: "#FF2D55",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/3c/f3/9a/3cf39ab5-0af3-eed7-aa39-3227fd3a65d7/Placeholder.mill/0x514h.jpg",
  },
  {
    id: 13,
    title: "Золотое Яблоко: скидки и акции",
    subtitle: "Shopping",
    rating: 4.2,
    ratingCount: "650K",
    price: 0,
    rank: 13,
    color: "#FF9500",
    icon: "https://play-lh.googleusercontent.com/HYanCfyE4fkeSUqL6s1Jpkg5W12gudi7Ioy_RnsCLMqgs1WC43u7Y9Aa-qOC77eI2BuhI2wJJMZqUzHVtO8Wrs4",
  },
  {
    id: 14,
    title: "Яндекс Пэй: QR, NFC и Сплит",
    subtitle: "Finance",
    rating: 4.4,
    ratingCount: "1.8M",
    price: 0,
    rank: 14,
    color: "#FFCC00",
    icon: "https://play-lh.googleusercontent.com/LsOdqa5TgM9c-WCScDwasUT-dZaYd_i4IX2azQWPfI4rD3MwNhgVtxgCfhM8DSWIvDfvnNVwUiq4gRVetBoqras",
  },
  {
    id: 15,
    title: "Вкусно — и точка: еда и акции",
    subtitle: "Food",
    rating: 4.3,
    ratingCount: "2.5M",
    price: 0,
    rank: 15,
    color: "#FF9500",
    icon: "https://play-lh.googleusercontent.com/7tnxpBpXguS4THUvv9Go5GSGI28fuZZzWTpASMuLGw2jUVqG005wqD8ilw3pRgFYyqtcX0Hn5QazuCzOCKvihWM",
  },
  {
    id: 16,
    title: "VK Video: movies, cartoons, TV",
    subtitle: "Entertainment",
    rating: 4.0,
    ratingCount: "1.2M",
    price: 0,
    rank: 16,
    color: "#0077FF",
    icon: "https://play-lh.googleusercontent.com/anTn7Xu1mAnUyEfE582QykZ7iX4Od6UKFw0mSQBt8EUyo5wjOq_rDwSpxUkVVNW995_gVD50FrQWugG355ly2Q",
  },
  {
    id: 17,
    title: "Cloud: Video, photo storage",
    subtitle: "Productivity",
    rating: 4.1,
    ratingCount: "890K",
    price: 0,
    rank: 17,
    color: "#005FF9",
    icon: "https://play-lh.googleusercontent.com/SyKoFBsi9MxPm4ElBqwCm49cq1le-xmgy_Ia2PDml5F7hT7dghkMGAMWmGgmznMO06q9ZuNX8ONdbGsVrbqDtA",
  },
  {
    id: 18,
    title: "Getcontact",
    subtitle: "Tools",
    rating: 4.2,
    ratingCount: "1.5M",
    price: 0,
    rank: 18,
    color: "#00B4D8",
    icon: "https://play-lh.googleusercontent.com/jBFbuUNAErBnt6Zfma8_MlcZNcARpNyXE06WoavbspXscOaQesCZSuwI0tUf8-rU2krf4u5kA5S1lQ6BrlsT",
  },
  {
    id: 19,
    title: "Boosty: Content just for fans",
    subtitle: "Social",
    rating: 4.0,
    ratingCount: "450K",
    price: 0,
    rank: 19,
    color: "#FF6B35",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource211/v4/d7/06/11/d7061159-2924-2f43-0af5-40b7ce6a456a/Placeholder.mill/0x514h.jpg",
  },
  {
    id: 20,
    title: "Kaspersky Who Calls: Нет Спама",
    subtitle: "Tools",
    rating: 4.3,
    ratingCount: "780K",
    price: 0,
    rank: 20,
    color: "#006633",
    icon: "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource221/v4/12/1a/fe/121afedd-7462-4b06-75d9-5ae4c30648bf/Placeholder.mill/0x514h.jpg",
  },
  {
    id: 21,
    title: "v2RayTun",
    subtitle: "Tools",
    rating: 4.1,
    ratingCount: "320K",
    price: 0,
    rank: 21,
    color: "#FF6B00",
    icon: "https://play-lh.googleusercontent.com/7DrGwiDNQ0kueI2GvddHD2D74ZUFIm041uVqfjqBlba0G6-7WsuxgQGruoEWSVLzd0rAh84w32jZ_FTE14SKLIA",
  },
];